import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import './AccordionSelectView.scss';
import template from './AccordionSelectView.html';
let AccordionSelectViewComponent = class AccordionSelectViewComponent {
    constructor() {
        this.imageuri = undefined;
        this.showimage = undefined;
        this.ischecked = false;
        this.item = undefined;
    }
};
AccordionSelectViewComponent = __decorate([
    Component({
        template,
        transclude: true,
        bindings: {
            title: '@',
            item: '<',
            imageuri: '<',
            showimage: '<',
            ischecked: '<',
            type: '@',
        },
    }),
    __metadata("design:paramtypes", [])
], AccordionSelectViewComponent);
export { AccordionSelectViewComponent };
